export const customBlurMixin = {
  inject: ["parentValidator"],
  data: function () {
    return {
      first_change: false,
      error: false,
    };
  },
  methods: {
    onChange() {
      this.first_change = true;
    },
    onBlur() {
      if (
        this.errors.has(this.validationLabel || this.label) &&
        this.first_change
      )
        this.error = true;
      else this.error = false;
    },
  },
};
